// extracted by css-extract-rspack-plugin
export default {"categorySelectList":"MHe69"};